document.addEventListener('click', (event) => {
  if (!window.matchMedia('(max-width: 59.99em)').matches) return;

  const openButton = event.target.closest('[data-menu-drawer-open-panel]');
  const backButton = event.target.closest('[data-menu-drawer-back]');

  if (!openButton && !backButton) return;

  const drawer = event.target.closest('header-drawer');
  if (!drawer) return;

  event.preventDefault();

  const targetPanelId = openButton
    ? openButton.getAttribute('data-menu-drawer-open-panel')
    : 'main';

  const currentPanel = drawer.querySelector('[data-menu-drawer-panel].is-active');
  const targetPanel = drawer.querySelector(`[data-menu-drawer-panel="${targetPanelId}"]`);

  if (!targetPanel || currentPanel === targetPanel) return;

  if (currentPanel) {
    currentPanel.hidden = true;
    currentPanel.classList.remove('is-active');
  }

  targetPanel.hidden = false;
  targetPanel.classList.add('is-active');

  if (window.gsap) {
    gsap.fromTo(targetPanel, {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      duration: 0.3
    });
  }
});
